import React, { memo, forwardRef } from "react";
const SvgSubset = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        fillRule="evenodd"
        d="M23 20a1 1 0 110 2h-7a8 8 0 110-16h7a1 1 0 110 2h-7a6 6 0 000 12h7zm0 6a1 1 0 100-2H9a1 1 0 100 2h14z"
        clipRule="evenodd"
      />
    </svg>
  );
});
SvgSubset.displayName = "SvgSubset";
const MemoForwardRef = memo(SvgSubset);
export default MemoForwardRef;
